module.exports = __webpack_public_path__ + "static/media/data_scientist_explain.0df54fbf.jpg";